import React, { createContext, useState } from 'react'

export const ProductDetailContext = createContext({
    data: {},
    docId: "",
    user2Id: "",
    handleData: () => {},
    handleDocId: () => {},
    handleUser2Id: () => {},
})

const ProductDetailsProvider = ({children}) => {
    const [data, setData] = useState({})
    const [docId, setDocId] = useState("")
    const [user2Id, setUser2Id] = useState("")

    const handleData = (data) => {
        setData(data)
    }

    const handleDocId = (docid) => {
      setDocId(docid)
    }

    const handleUser2Id = (user2Id) => {
      setUser2Id(user2Id)
    }

  return (
    <ProductDetailContext.Provider value={{data: data, handleData: handleData, docId: docId, handleDocId: handleDocId, user2Id: user2Id, handleUser2Id: handleUser2Id}}>
        {children}
    </ProductDetailContext.Provider>
  )
}

export default ProductDetailsProvider